<template>
  <div>
    <v-btn color="green" class="" icon x-large @click="dialog = true"
      ><v-icon>mdi-plus-box</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Add Account"
          icon="mdi-account-plus"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-text-field
              outlined
              dense
              label="Username"
              v-model="form.username"
              :rules="[(v) => !!v || 'Username is required']"
              prepend-icon="mdi-account-circle"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="Password"
              v-model="form.password"
              :rules="[(v) => !!v || 'Password is required']"
              prepend-icon="mdi-form-textbox-password"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="Full Name"
              v-model="form.full_name"
              prepend-icon="mdi-account-circle-outline"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="Address"
              v-model="form.address"
              prepend-icon="mdi-map-marker"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="Phone Number"
              v-model="form.phone_number"
              prepend-icon="mdi-phone"
            ></v-text-field>
            <v-autocomplete
              outlined
              dense
              :items="hats"
              label="Hats"
              v-model="form.hat_ids"
              item-text="name"
              item-value="id"
              multiple
              chips
              small-chips
              deletable-chips
              prepend-icon="mdi-hard-hat"
              hint="Stackable permission bundles - an account can hold several hats"
              persistent-hint
            ></v-autocomplete>
            <v-select
              outlined
              dense
              prepend-icon="mdi-domain"
              :items="branches"
              label="Branch"
              item-text="branch_name"
              item-value="id"
              v-model="form.branch_id"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit" :loading="loading">Add</v-btn>
          <v-btn @click="dialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">addAccountModal.vue</p>
        </v-card-actions>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      loading: false,
      ready: false,
      dialog: false,
      form: {},
    };
  },
  methods: {
    ...mapActions({
      add_account: "auth/add_user",
      get_branches: "branch/get_branches",
      fetch_hats: "permission/fetch_hats",
    }),
    async submit() {
      if (!this.$refs.form.validate()) return;
      let x = await this.$confirm({
        title: "Add Account",
        message: "Are you sure you want to add this account?",
        color: "primary",
        icon: "mdi-help-circle-outline",
      });
      if (!x) return;
      this.loading = true;
      try {
        await this.add_account(this.form);
        this.$alert({
          title: "Success",
          message: "Successfully added a new account",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.$refs.form.reset();
        this.form = {};
        this.dialog = false;
      } catch (e) {
        this.$alert({
          title: "Error",
          message:
            e?.response?.data?.message ||
            "Failed to add account. Please try again.",
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      branches: "branch/branches",
      hats: "permission/hats",
    }),
  },
  async created() {
    if (this.branches.length == 0) this.get_branches();
    if (this.hats.length == 0) this.fetch_hats();
  },
};
</script>
<style lang="scss" scoped></style>
